"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CwShellSizes = exports.CwShellLeftNavExpand = void 0;
var CwShellLeftNavExpand = {
  COLLAPSED: 'Collapsed',
  DEFAULT: 'Default',
  FAT: 'Fat',
  SKINNY: 'Skinny'
};
exports.CwShellLeftNavExpand = CwShellLeftNavExpand;
var CwShellSizes = {
  COLLAPSED: 32,
  DEFAULT: 88,
  FAT: 192,
  SKINNY: 56
};
exports.CwShellSizes = CwShellSizes;